import { experiments } from '../../experiments';
import { renderModel } from '../../util/renderModel';

export const useIsCopilotRedesign = (): boolean =>
  renderModel.isCopilot() && experiments.is('specs.ArticlePageRedesignUnifiedUX', 'true');
